import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>Copyright &copy; 2021 | Phanindra Reddy</p>
        </div>
    )
}

export default Footer;
